import { jsx } from 'react/jsx-runtime';
import React__default from 'react';
import { EmbedWrapper } from './EmbedWrapper.js';
import { YOUTUBE_URL_REGEX } from '../../expandedResource.utils.js';

const YoutubeEmbed = ({ url, children }) => {
  const { videoId, isVertical } = React__default.useMemo(() => {
    const execResult = new RegExp(YOUTUBE_URL_REGEX).exec(url);
    const videoId2 = execResult && execResult[execResult.length - 1];
    if (!videoId2) {
      return {
        videoId: null,
        isVertical: false
      };
    }
    return {
      videoId: videoId2,
      isVertical: url.includes("/shorts/")
    };
  }, [
    url
  ]);
  if (!videoId) {
    return children;
  }
  return /* @__PURE__ */ jsx(EmbedWrapper, {
    orientation: isVertical ? "vertical" : void 0,
    children: /* @__PURE__ */ jsx("iframe", {
      src: `https://www.youtube.com/embed/${videoId}`,
      allowFullScreen: true
    })
  });
};

export { YoutubeEmbed };
//# sourceMappingURL=YoutubeEmbed.js.map
